var _circle, _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.5,
    fill: "#FAFAFA",
    stroke: "#E8E8E8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    transform: "translate(7 7)",
    fill: "#FAFAFA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5275_1150)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4853 13.4574L16.5427 12.5147L10.3333 18.7241V19.6667H11.276L17.4853 13.4574ZM18.428 12.5147L19.3707 11.5721L18.428 10.6294L17.4853 11.5721L18.428 12.5147ZM11.828 21.0001H9V18.1714L17.9567 9.21472C18.0817 9.08974 18.2512 9.01953 18.428 9.01953C18.6048 9.01953 18.7743 9.08974 18.8993 9.21472L20.7853 11.1007C20.9103 11.2257 20.9805 11.3953 20.9805 11.5721C20.9805 11.7488 20.9103 11.9184 20.7853 12.0434L11.828 21.0001Z",
    fill: "#858585"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5275_1150"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.51f90538804046bb914925f9457bf29a.svg";
export { ForwardRef as ReactComponent };